import { GeneralInfoNav } from "./generalInfoComponents/generalInfoNav";
import { useSearchParams } from "react-router-dom";
import { GeneralInfoCompany } from "./generalInfoComponents/generalInfoCompany";
import { GeneralInfoUsers } from "./generalInfoComponents/generalInfoUsers";
import { GeneralInfoPickup } from "./generalInfoComponents/generalInfoPickup";
import { GeneralInfoPayment } from "./generalInfoComponents/generalInfoPayment";
import { useGetCompanyBOV1 } from "@/api/company.api";

type InformationsProps = {
  companyId: string;
};

export const Informations = ({ companyId }: InformationsProps) => {
  const [searchParams] = useSearchParams();

  const { data: company } = useGetCompanyBOV1(companyId, {
    includeBillingEntities: true,
    includePickUpLocations: true,
  });

  const displayTab = () => {
    switch (Number(searchParams.get("subTab")) || 0) {
      case 0:
        return <GeneralInfoCompany company={company} />;
      case 1:
        return <GeneralInfoUsers company={company} />;
      case 2:
        return <GeneralInfoPickup company={company} />;
      case 3:
        return <GeneralInfoPayment company={company} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex w-full flex-1 flex-col items-center gap-8">
      <GeneralInfoNav />
      {displayTab()}
    </div>
  );
};
